// import React, { Fragment, use, useRef, useState } from 'react'
// import { Dialog, Transition } from '@headlessui/react';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const ConfirmBooking = ({ isOpen, closeModal, quote_id, bid_id }) => {

//   const focusRef = useRef(null);

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/service-quote-booking`, {
//         service_quote_id: quote_id,
//         service_quote_bid_id: bid_id
//       }, {
//         headers: {
//           "Content-Type": 'multipart/form-data',
//           "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
//         },
//       });

//       if (response.data.status) {
//         window.location = response.data.data.payment_link;
//       }
//       else {
//         toast.error(response.data.message);
//       }
//     } catch (error) {
//       toast.error('An error occured');
//     }
//   }

//   const handleCloseModal = () => {
//     closeModal();
//   }

//   return (
//     <React.Fragment>
//       <Transition appear as={Fragment} show={isOpen}>
//         <Dialog as='div' className={'relative z-50'} onClose={handleCloseModal} initialFocus={focusRef}>

//           {/* BackDrop Overlay */}
//           <Transition.Child
//             as={Fragment}
//             enter='ease-in-out duration-300'
//             enterFrom='opacity-0'
//             enterTo='opacity-100'
//             leave='ease-in-out duration-300'
//             leaveFrom='opacity-100'
//             leaveTo='opacity-0'>
//             <div className='fixed inset-0 bg-black bg-opacity-50' />
//           </Transition.Child>

//           <div className='fixed inset-0 overflow-y-auto'>
//             <div className='min-h-full flex items-center justify-center p-4 text-center'>

//               {/* Modal Dialog */}
//               <Transition.Child
//                 as={Fragment}
//                 enter='ease-in-out duration-300'
//                 enterFrom='opacity-0 scale-90'
//                 enterTo='opacity-100 scale-100'
//                 leave='ease-in-out duration-300'
//                 leaveFrom='opacity-100 scale-100'
//                 leaveTo='opacity-0 scale-90'>
//                 <Dialog.Panel className={"relative w-full max-w-3xl bg-white max-h-[90vh] overflow-y-auto transform shadow-lg flex flex-col lg:p-10 sm:p-7 text-left"} ref={focusRef}>
//                   <form onSubmit={(event) => handleFormSubmit(event)} className='space-y-3'>
//                     <div className='space-y-0.5'>
//                       <h1 className='text-xl font-semibold'>Confirm this Bid</h1>
//                       <p className='text-sm text-gray-500'>You have to agree the below term & conditions to confirm this booking</p>
//                     </div>
//                     <div className='h-[30vh] overflow-y-scroll border p-2 text-sm'>
//                       <h1 className='mb-2 font-medium text-base'>Terms & Conditions</h1>
//                       <p>By confirming a bid on the Homegurus portal, the customer formally agrees to proceed with the selected vendor based on the details provided in the bid, including but not limited to the scope of work, pricing, materials, timelines, and any specific conditions outlined therein.
//                         <br /><br />The vendor, upon confirmation, is obligated to deliver the agreed-upon construction-related services in a professional and timely manner, adhering to all specifications mentioned in the bid.
//                         <br /><br />Homegurus acts solely as a neutral aggregator and facilitator, providing a digital platform for customers and vendors to connect and transact. Homegurus is not a party to the contract between the customer and vendor and assumes no responsibility for the execution, quality, timeliness, or outcomes of the services rendered.
//                         <br /><br />Any disputes, changes, or issues arising from the agreement must be resolved directly between the customer and the vendor, and Homegurus shall not be held liable for any loss, damage, or dissatisfaction resulting from the engagement.</p>
//                     </div>
//                     <div className='space-y-3'>
//                       <div className='flex items-center justify-start'>
//                         <input type="checkbox" required name='accept_terms' className='cursor-pointer' id='accept_terms' />
//                         <label htmlFor="accept_terms" className='font-medium text-sm cursor-pointer'>I accept the terms & conditions</label>
//                       </div>
//                       <button className='btn-primary-sm'>Confirm Booking</button>
//                     </div>
//                     <div>
//                       <p className='text-xs text-gray-500'>Note: You will redirect to payment gateway after confirming the booking</p>
//                     </div>
//                   </form>
//                 </Dialog.Panel>
//               </Transition.Child>
//               {/* Modal Dialog */}

//             </div>
//           </div>

//         </Dialog>
//       </Transition>
//     </React.Fragment>
//   )
// }

// export default ConfirmBooking

import React, { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ConfirmBooking = ({ isOpen, closeModal, quote_id, bid_id }) => {

  const focusRef = useRef(null);
  const [loading, setLoading] = useState(false); // ⬅️ Add loading state

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // ⬅️ Start loading
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/service-quote-booking`, {
        service_quote_id: quote_id,
        service_quote_bid_id: bid_id
      }, {
        headers: {
          "Content-Type": 'multipart/form-data',
          "Authorization": `Bearer ${localStorage.getItem('accessToken')}`
        },
      });

      if (response.data.status) {
        window.location = response.data.data.payment_link;
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('An error occurred');
    } finally {
      setLoading(false); // ⬅️ Stop loading
    }
  }

  const handleCloseModal = () => {
    closeModal();
  }

  return (
    <React.Fragment>
      <Transition appear as={Fragment} show={isOpen}>
        <Dialog as='div' className={'relative z-50'} onClose={handleCloseModal} initialFocus={focusRef}>
          <Transition.Child
            as={Fragment}
            enter='ease-in-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in-out duration-300'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'>
            <div className='fixed inset-0 bg-black bg-opacity-50' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='min-h-full flex items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-in-out duration-300'
                enterFrom='opacity-0 scale-90'
                enterTo='opacity-100 scale-100'
                leave='ease-in-out duration-300'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-90'>
                <Dialog.Panel className={"relative w-full max-w-3xl bg-white max-h-[90vh] overflow-y-auto transform shadow-lg flex flex-col lg:p-10 sm:p-7 text-left"} ref={focusRef}>
                  <form onSubmit={handleFormSubmit} className='space-y-3'>
                    <div className='space-y-0.5'>
                      <h1 className='text-xl font-semibold'>Confirm this Bid</h1>
                      <p className='text-sm text-gray-500'>You have to agree the below term & conditions to confirm this booking</p>
                    </div>
                    <div className='h-[30vh] overflow-y-scroll border p-2 text-sm'>
                      <h1 className='mb-2 font-medium text-base'>Terms & Conditions</h1>
                      <p>By confirming a bid on the Homegurus portal, the customer formally agrees to proceed with the selected vendor based on the details provided in the bid, including but not limited to the scope of work, pricing, materials, timelines, and any specific conditions outlined therein.
                        <br /><br />The vendor, upon confirmation, is obligated to deliver the agreed-upon construction-related services in a professional and timely manner, adhering to all specifications mentioned in the bid.
                        <br /><br />Homegurus acts solely as a neutral aggregator and facilitator, providing a digital platform for customers and vendors to connect and transact. Homegurus is not a party to the contract between the customer and vendor and assumes no responsibility for the execution, quality, timeliness, or outcomes of the services rendered.
                        <br /><br />Any disputes, changes, or issues arising from the agreement must be resolved directly between the customer and the vendor, and Homegurus shall not be held liable for any loss, damage, or dissatisfaction resulting from the engagement.</p>
                    </div>
                    <div className='space-y-3'>
                      <div className='flex items-center justify-start'>
                        <input type="checkbox" required name='accept_terms' className='cursor-pointer' id='accept_terms' />
                        <label htmlFor="accept_terms" className='font-medium text-sm cursor-pointer'>I accept the terms & conditions</label>
                      </div>
                      <button className='btn-primary-sm' type="submit" disabled={loading}>
                        {loading ? 'Processing...' : 'Confirm Booking'}
                      </button>
                    </div>
                    <div>
                      <p className='text-xs text-gray-500'>Note: You will redirect to payment gateway after confirming the booking</p>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>

        </Dialog>
      </Transition>
    </React.Fragment>
  )
}

export default ConfirmBooking;
